export default "__VITE_ASSET__BkztjWIs__"